import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BackHandler = ({ handleCustomBack }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handlePopState = (e) => {
      e.preventDefault();
      handleCustomBack(location.pathname, navigate);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [location.pathname, handleCustomBack, navigate]);

  return null;
};

export default BackHandler;
